/* @flow */
import * as React from 'react';

const HomeSmallAlt = props => (
  <svg
    width={70}
    height={55}
    viewBox="0 0 70 55"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      fill="#E8EBF7"
      d="M14.112,8.669 C21.078,8.669 26.724,40.884 26.724,45.374 C26.724,49.865 21.078,53.505 14.112,53.505 C7.147,53.505 1.5,49.865 1.5,45.374 C1.5,40.884 7.147,8.669 14.112,8.669 Z"
    />
    <path d="M26,46.021 C26,41.614 20.403,10 13.5,10 C6.597,10 1,41.614 1,46.021 C1,50.427 6.597,54 13.5,54 C20.403,54 26,50.427 26,46.021 Z" />
    <path d="M14,53 L14,31" />
    <path d="M14.112,45.031 L9.678,41.914" />
    <polygon
      fill="#FFFFFF"
      points="66.961 26.262 44.805 8.669 23.014 26.112 23.014 53.505 66.961 53.505"
    />
    <polyline points="67 26 67 54 22 54 22 26" />
    <polygon fill="#1D2C61" points="21 20.22 44.858 1 69 20.333 69 29 44.858 9.668 21 28.889" />
    <polygon points="21 20.22 44.858 1 69 20.333 69 29 44.858 9.668 21 28.889" />
    <polygon fill="#1D2C61" points="31 44 41 44 41 34 31 34" />
    <polygon points="30 45 42 45 42 33 30 33" />
    <rect fill="#FFFFFF" x={35} y={32} width={2} height={15} />
    <polygon fill="#FFFFFF" points="35.5 31 37.5 31 37.5 47 35.5 47" />
    <polygon fill="#1D2C61" points="50 53 59 53 59 38 50 38" />
    <polygon points="50 53 59 53 59 38 50 38" />
  </svg>
);

export default HomeSmallAlt;



// WEBPACK FOOTER //
// ./src/assets/images/icons/home-small-alt.js